import { Model } from '../model';
import { Paginated } from '../paginated';

export class MessageType extends Model {
  id: string;
  label: string;
  settableCustomSender: boolean;
  settableDeliveryNotification: boolean;
}

export class MessageTypes extends Paginated {
  data: Array<MessageType>;
}
